<script setup lang="ts">
const { count = 2 } = defineProps<{
  count?: number;
}>();
</script>

<template>
  <ul
    class="pt-6 pb-4 h-full md:pl-0"
    data-cy="event-list-skeleton"
  >
    <li
      v-for="eventIndex in count"
      :key="eventIndex"
      class="mb-4 lg:mb-8"
    >
      <div class="flex justify-between mb-2 h-12 md:h-14">
        <div class="event-list-skeleton__header--left w-1/3 overflow-hidden">
          <BaseSkeletonLoader
            :width="200"
            :height="200"
          />
        </div>
      </div>
      <ul class="flex pt-4 gap-x-1 overflow-hidden">
        <ProductCardSkeleton
          v-for="productIndex in 5"
          :key="productIndex"
          as="li"
        />
      </ul>
    </li>
  </ul>
</template>

<style scoped lang="postcss">
.event-list-skeleton__header--left {
  svg {
    @apply w-full;
  }
}
</style>
